import { i18n } from '@/i18n';
import { VehicleExtraType } from '@carvia/ros-client-types';

type LedgerEntryDescription = {
  type?: string;
  extraType?: VehicleExtraType;
};

/** Period lanes: `rental_fee:0`, `extra:CROSSBORDER:1`, `custom_extra:{id}:2`. */
const PERIOD_LEDGER_LANE = /^(rental_fee|extra:.+|custom_extra:.+):(\d+)$/;

export const getTranslatedLedgerEntryLane = (
  lane: string,
  description?: LedgerEntryDescription,
) => {
  const t = i18n.global.t;
  const periodMatch = lane.match(PERIOD_LEDGER_LANE);
  const [laneType, laneSubType] = (periodMatch?.[1] ?? lane).split(':');

  // Coupon additional extras use custom_extra:{uuid} with an EXTRA description.
  let label: string;
  if (laneType === 'custom_extra' && description?.type === 'extra' && description.extraType) {
    label = `${t('couponBenefit')} – ${t(`vehicleExtras.${description.extraType}`)}`;
  } else {
    switch (laneType) {
      case 'extra':
        label = `${t('ledgerEntryLanes.extra')} – ${t(`vehicleExtras.${laneSubType}`)}`;
        break;
      case 'additional_costs':
        label = `${t('ledgerEntryLanes.additional_costs')} – ${t(`ledgerEntryLanes.additionalCostsSubType.${laneSubType}`)}`;
        break;
      case 'custom_extra':
        label = `${t('ledgerEntryLanes.custom_extra')} – ${laneSubType}`;
        break;
      case 'invoice':
        label = `${t('ledgerEntryLanes.invoice')} – ${t(`invoiceTypes.${laneSubType}`)}`;
        break;
      case 'cancellation_fee':
        label = t('ledgerEntryLanes.cancellation_fee');
        break;
      default:
        label = t(`ledgerEntryLanes.${laneType}`);
    }
  }

  if (periodMatch) {
    return `${label} – ${t('ledgerEntryLanes.period', { n: Number(periodMatch[2]) + 1 })}`;
  }
  return label;
};
